import React, { useEffect } from "react";
import {
  AppBar,
  Button,
  Typography,
  Box,
  CssBaseline,
  Container,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import banner3 from "../images/banner7.jpg";
import "../App.css";
import banner2 from "../images/banner5.jpg";
import banner1 from "../images/banner6.jpg";
import { styled } from "@mui/system";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import Header from "./Header";

const Slide = styled(Box)(({ backgroundImage }) => ({
  backgroundImage: `url(${backgroundImage})`,
  backgroundSize: "cover",
  width: "100vw",
  maxWidth: "1900px",
  backgroundPosition: "center",
  height: "100vh",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  position: "relative",
  color: "#fff",
  textAlign: "center",

  "&:after": {
    content: "''",
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(212, 212, 212, 0.34)",
    zIndex: 1,
  },
  "> *": {
    position: "relative",
    zIndex: 2,
  },
}));

const GlobalStyles = styled("style")`
  @keyframes fadeInUp {
    0% {
      opacity: 0;
      transform: translateY(90px);
    }
    100% {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

export default function Banner() {

  const navigate = useNavigate();

  useEffect(() => {
    // Add any mount effects if needed
  }, []);

  const settings = {
    dots: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: true,
  };

  const backgroundImages = [banner1, banner2, banner3];

  const handleNavigation = (path) => {
    navigate(path);
  };

  return (
    <>
      <CssBaseline />
      <GlobalStyles />

      {/* AppBar */}
      <AppBar
        position="absolute"
        color="transparent"
        elevation={0}
      >
        <Header />
      </AppBar>

      {/* Banner Section with Carousel */}
      <Slider {...settings}>
        {backgroundImages.map((image, index) => (
          <Slide key={index} backgroundImage={image}>
            <Container
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
                mt: { xs: 8, md: 6 },
              }}
            >
              {/* Title */}
              <Typography
                variant="h2"
                sx={{
                  fontWeight: 700,
                  marginBottom: 2,
                  color: "black",
                  animation: "fadeInUp 1.5s ease-in-out",
                  fontSize: { xs: "1rem", md: "3rem" },
                }}
              >
                Global Procurement Excellence
              </Typography>

              {/* Description */}
              <Typography
                variant="h6"
                sx={{
                  marginBottom: 8,
                  maxWidth: "1000px",
                  mt: 2,
                  color: "black",
                  animation: "fadeInUp 1.5s ease-in-out",
                  fontSize: { xs: "1rem", md: "1.25rem" },
                  textAlign: "center",
                  fontWeight: "normal",
                }}
              >
                Reliable, Compliant, and Professional Sourcing Solutions for Defence and International Trade
              </Typography>

              {/* Buttons - Updated with new names and routes */}
              <Box
                sx={{
                  display: "flex",
                  flexWrap: "wrap",
                  justifyContent: "center",
                  gap: { xs: 2, md: 12 },
                  animation: "fadeInUp 1.5s ease-in-out",
                }}
              >
                {/* Explore Our Services Button */}
                <Button
                  variant="contained"
                  onClick={(e) => e.preventDefault()} // prevent default navigation
                  sx={{
                    padding: "12px 34px",
                    backgroundColor: "#0f758e73",
                    transition:
                      "background-color 0.3s ease, border-color 0.3s ease",
                    border: "2px solid #0F758E",
                    fontWeight: 900,
                    fontSize: { xs: "0.7rem", md: "1rem" },
                    "&:hover": {
                      backgroundColor: "#0F758E",
                      borderColor: "#0F758E",
                    },
                  }}
                >
                  Explore Our Services
                </Button>

                {/* View Current Tenders Button */}
                <Button
  variant="contained"
  onClick={(e) => e.preventDefault()} // prevent default navigation
  sx={{
    padding: "12px 32px",
    backgroundColor: "#0f758e73",
    transition: "background-color 0.3s ease, border-color 0.3s ease",
    border: "2px solid #0F758E",
    fontWeight: 900,
    fontSize: { xs: "0.7rem", md: "1rem" },
    "&:hover": {
      backgroundColor: "#0F758E",
      borderColor: "#0F758E",
    },
  }}
>
  View Current Tenders Button
</Button>



              </Box>

              {/* Submit a Sourcing Request Button */}
              <Button
                variant="contained"
                onClick={(e) => e.preventDefault()} // prevent default navigation
                sx={{
                  padding: "12px 30px",
                  backgroundColor: "#0f758e73",
                  transition:
                    "background-color 0.3s ease, border-color 0.3s ease",
                  border: "2px solid #0F758E",
                  mt: { xs: 2, md: 4 },
                  fontWeight: 900,
                  animation: "fadeInUp 1.5s ease-in-out",
                  fontSize: { xs: "0.7rem", md: "1rem" },
                  "&:hover": {
                    backgroundColor: "#0F758E",
                    borderColor: "#0F758E",
                  },
                }}
              >
                Submit a Sourcing Request
              </Button>
            </Container>
          </Slide>
        ))}
      </Slider>
    </>
  );
}